import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useIdFromRoute } from '../../../hooks/useIdFromRoute';
import { IQuestionnairesPayload, Questionnaires, QuestionnairesJson } from '../Questionnaires.ts';
import { AppMedError } from '../../../error/AppMedError.ts';
import { QuestionnairesApi } from '../../../apis/QuestionnairesApi/QuestionnairesApi.ts';

export function usePutQuestionnaires() {
    const queryClient = useQueryClient();
    const id = useIdFromRoute();

    return useMutation<IQuestionnairesPayload, AppMedError, IQuestionnairesPayload>({
        mutationKey: [QueryKeys.questionnaire, id],
        mutationFn: async (variables) => {
            if (!id) 
                throw new Error('Missing questionnaire ID');
            
            await QuestionnairesApi.putQuestionnaires(variables, id);
            return variables;
        },
        onSuccess: (updatedData) => {
            // Mettre à jour la liste complète
            queryClient.setQueryData<Questionnaires[]>(
                [QueryKeys.questionnaires],
                (prev) =>
                    (prev
                        ? prev.map((q) => (q.id === Number(id) ? { ...q, ...updatedData } : q))
                        : [{ ...updatedData, id }]) as Questionnaires[],
            );
            // Mettre à jour le détail
            queryClient.setQueryData<QuestionnairesJson>([QueryKeys.questionnaire, id], (prev) =>
                prev ? { ...prev, ...updatedData } : { ...updatedData, id },
            );
        },
    });
}
